import React, { useEffect } from 'react'
import { OptionType } from '../../../redux/reducers/ISBNSReducer';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../redux/store';
import { FetchTitleListAmazonRecord } from '../../../redux/reducers/titleListAmazonReducer';
import { FetchTitleListBookScanSalesRecord } from '../../../redux/reducers/titleListBookscanSalesReducer';
import { FetchTitleListReaderLinkRecord } from '../../../redux/reducers/titleListReaderLinkReducer';
import Loading from '../../../common-components/Loader';
import { formatPosDataAsOf } from '../../../common-components/commonFunctions';

interface posSalesProps {
    selectedIsbnOption : OptionType | null;
    selectedTitleOption : OptionType | null;
}

const PosSales:React.FC<posSalesProps> = ({selectedIsbnOption,selectedTitleOption}) => {
    const dispatch = useDispatch<AppDispatch>();
    const amazonData = useSelector((state: RootState) => state.titleListAmazonReducer);
    const bookscanSales = useSelector((state: RootState) => state.titleSalesBookScanReducer);
    const readerLinkSales = useSelector((state: RootState) => state.titleListReaderLinkReducer);

    useEffect(() => {
        if (selectedIsbnOption?.label) {
            dispatch(
                FetchTitleListAmazonRecord({
                    SelectedEbookIsbn: selectedIsbnOption.label,
                })
            );
            dispatch(
                FetchTitleListBookScanSalesRecord({
                    SelectedEbookIsbn: selectedIsbnOption.label,
                })
            );
            dispatch(
                FetchTitleListReaderLinkRecord({
                    SelectedEbookIsbn: selectedIsbnOption.label,
                })
            );
        }
    }, [selectedIsbnOption, dispatch]);

    const formatUnits = (value: any) => {
        if (value === null || value === undefined) return 0;
        const num = Number(value);
        if (isNaN(num)) return value;
        return num.toLocaleString("en-US", {
            maximumFractionDigits: 0,
            minimumFractionDigits: 0,
        });
    };

    const amazonMetrics = [
        {
            label: "MTD",
            value: selectedIsbnOption?.value
                ? amazonData.data.mtdData.MTD_UNITS_SALES ?? 0
                : 0,
        },
        {
            label: "YTD",
            value: selectedIsbnOption?.value
                ? amazonData.data.ytdData?.YTD_UNITS_SALES ?? 0
                : 0,
        },
        {
            label: "LTD",
            value: selectedIsbnOption?.value
                ? amazonData.data.ltdData?.LTD_UNITS_SALES ?? 0
                : 0,
        },
    ];

    const bookscanMetrics = [
        {
            label: "LW",
            value: selectedIsbnOption?.value
                ? bookscanSales.data.lwData?.LAST_WEEK_SALES ?? 0
                : 0,
        },
        {
            label: "YTD",
            value: selectedIsbnOption?.value
                ? bookscanSales.data.ytdData?.YTD_SALES ?? 0
                : 0,
        },
        {
            label: "LTD",
            value: selectedIsbnOption?.value
                ? bookscanSales.data.ltdData?.LTD_SALES ?? 0
                : 0,
        },
    ];

    const readerLinkMetrics = [
        {
            label: "MTD",
            value: selectedIsbnOption?.value
                ? readerLinkSales.data.mtdData?.MTD ?? 0
                : 0,
        },
        {
            label: "YTD",
            value: selectedIsbnOption?.value
                ? readerLinkSales.data.ytdData?.YTD ?? 0
                : 0,
        },
        {
            label: "LTD",
            value: selectedIsbnOption?.value
                ? readerLinkSales.data.ltdData?.LTD ?? 0
                : 0,
        },
    ];

    const amazonAsOf = formatPosDataAsOf(amazonData.data.dataAsOf ?? undefined);
    const bookscanAsOf = formatPosDataAsOf(bookscanSales.data.dataAsOf ?? undefined);
    const readerLinkAsOf = formatPosDataAsOf(readerLinkSales.data.dataAsOf ?? undefined);

  return (
    <div className='w-full mt-0 mb-4'>
        {/* <div className="w-full bg-gray-400 py-1.5 mb-2 text-[16px] font-bold text-center ">
            POS Data
        </div> */}
        <div className="w-full p-4 text-[16px] border-2 my-2 border-gray-300 flex flex-col items-center justify-center rounded-lg gap-3">
            {/* Amazon POS Section */}
            <div className="w-full border-2 border-gray-300 rounded-lg">
            <div className="w-full bg-[#e31c23] py-2 text-[12px] font-bold text-center text-white">
    Amazon POS{amazonAsOf ? ` as of ${amazonAsOf}` : ""}
</div>

                <Loading isLoading={amazonData.isLoading}>
                    <div className="p-4">
                        <div className="text-[18px] w-full flex justify-around">
                            {amazonMetrics.map((data, index) => (
                                <div key={index} className="flex flex-col">
                                    <p className="text-[#e31c23] font-semibold text-[16px] text-center">
                                        {data.label}
                                    </p>
                                    <p className="text-center text-gray-700 font-semibold text-lg">
                                        {formatUnits(data.value)}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>
                </Loading>
            </div>

            {/* BookScan POS Section */}
            <div className="w-full border-2 border-gray-300 rounded-lg">
                <div className="w-full  bg-[#e31c23]  py-2 text-[12px] font-bold text-center text-white">
                    BookScan POS{bookscanAsOf ? ` as of ${bookscanAsOf}` : ""}
                </div>
                <Loading isLoading={bookscanSales.isLoading}>
                    <div className="p-4">
                        <div className="text-[18px] w-full flex justify-around">
                            {bookscanMetrics.map((data, index) => (
                                <div key={index} className="flex flex-col">
                                    <p className="text-[#e31c23] font-semibold text-[16px] text-center">
                                        {data.label}
                                    </p>
                                    <p className="text-center text-gray-700 font-semibold text-lg">
                                        {formatUnits(data.value)}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>
                </Loading>
            </div>

            <div className="w-full border-2 border-gray-300 rounded-lg">
                <div className="w-full  bg-[#e31c23]  py-2 text-[12px] font-bold text-center text-white">
                    ReaderLink POS{readerLinkAsOf ? ` as of ${readerLinkAsOf}` : ""}
                </div>
                <Loading isLoading={readerLinkSales.isLoading}>
                    <div className="p-4">
                        <div className="text-[18px] w-full flex justify-around">
                            {readerLinkMetrics
                                .filter((metric) => metric.label !== "LTD")
                                .map((data, index) => (
                                    <div key={index} className="flex flex-col">
                                        <p className="text-[#e31c23] font-semibold text-[16px] text-center">
                                            {data.label}
                                        </p>
                                        <p className="text-center text-gray-700 font-semibold text-lg">
                                            {formatUnits(data.value)}
                                        </p>
                                    </div>
                                ))}
                        </div>
                    </div>
                </Loading>
            </div>
        </div>
    </div>
  )
}

export default PosSales